import React from 'react';

const CompanyStorySection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Our <strong>Story</strong>
            </h2>
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                Professional Office Group was founded with a simple mission: to provide South Carolina businesses 
                with exceptional office furniture solutions that combine quality, affordability, and outstanding service. 
                We understand that your workspace is more than just furniture – it's where productivity happens, 
                relationships are built, and success is achieved.
              </p>
              <p>
                Over the years, we've built strong relationships with leading furniture manufacturers, allowing us 
                to offer the best prices around while maintaining the highest quality standards. Our team of 
                experienced professionals brings deep knowledge of commercial furniture design, space planning, 
                and installation services.
              </p>
              <p>
                From small startups to large corporations across South Carolina and surrounding states, we've 
                helped countless businesses create functional, beautiful workspaces that inspire their teams 
                and impress their clients. We're not just furniture dealers – we're workspace transformation experts.
              </p>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/e902c1c4b148220bbbb5dabc45568258.jpg"
              alt="Professional Office Group warehouse and showroom"
              className="rounded-lg shadow-xl object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -right-6 bg-orange-500 text-white p-6 rounded-lg shadow-lg">
              <div className="text-center">
                <div className="text-2xl font-bold">15+</div>
                <div className="text-sm">Years of Excellence</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStorySection;